<template>
  <div class="course p_t">
    <TopHead title="课程介绍"></TopHead>
    <div class="c_c">
      <van-collapse
        accordion
        v-model="activeNames"
      >
        <van-collapse-item :title="item.commodityTypeName" :name="index" v-for="(item,index) in titleArr" :key="index">
          <div class="items d_i" @click="$router.push('/CourseDetail?commodityId='+itm.commodityId)" v-for="(itm,idx) in item.classInfo" :key="idx">
            <van-image fit="cover" :src="itm.commodityCoverOne" class="top"/>

            <!--<img src="../assets/img/about_bg.png" alt="" class="top">-->
            <div class="item_c">
              <div class="name">{{itm.commodityName}}</div>
              <div class="d">{{itm.synopsis}}</div>
              <div class="tag d_f ali_c">
                <template v-for="(im,ix) in itm.hotTagList" :key="ix">
                  <img :src="imgArr[Number(im-1)]" :alt="im" v-if="im">
                </template>
              </div>
            </div>
          </div>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
  import classRe from '../assets/img/class_re.png'
  import classJing from '../assets/img/class_jing.png'
  import classHui from '../assets/img/class_hui.png'
  export default {
    name: "Course",
    data() {
      return {
        activeNames:'',
        loading:'',
        titleArr:[],
        imgArr:[classRe,classJing,classHui],
      }
    },
    created(){
      this.listCommodityType();
    },
    methods: {
      // 根据code获取课程
      listCommodity(code,index){
        let params = {
          commodityName:'',
          commodityTypeCode:code,
          recommendFlag:0,
          pageIndex:1,
          pageSize:1000,
        };
        this.$api.listCommoditys(params).then(res => {
          this.loading = false;
          this.titleArr[index].classInfo = JSON.parse(JSON.stringify(res.data.rows))
        })
      },
      //获取菜单
      listCommodityType(){
        this.loading = true;
        this.$api.listCommodityType({parentCommodityTypeCode:'kcjs',mallFlag:'0'}).then(res => {
          this.titleArr = res.data;
          this.titleArr.map((item,index) => {
            item.classInfo = [];
            this.listCommodity(item.commodityTypeCode,index)
          });
        })
      },
    }
  }
</script>

<style scoped lang="scss">
  .c_c{
    .items{
      .item_c{
        .tag{
          img{
            width: 13px;
            height: 14px;
            margin-right: 10px;
          }
          margin-top: 10px;
          border-top: 1px solid #E1E1E1;
          padding: 10px 0;
        }
        .d{
          /*height: 36px;*/
          font-size: 10px;
          font-weight: 500;
          color: #333333;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .name{
          font-size: 14px;
          font-weight: bold;
          color: #333333;
          margin-bottom: 6px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        padding: 8px 6px;
      }
      .top{
        height: 117px;
      }
      margin-bottom: 20px;
      box-sizing: border-box;
      overflow: hidden;
      background: #FFFFFF;
      border: 1px solid #DADADA;
      border-radius: 4px;
      width: calc((100% - 15px) / 2);
      &:nth-child(odd){
        margin-right: 15px;
      }
    }
    padding: 0 13px;
  }

</style>
